import { createUseStyles } from 'react-jss';

export default createUseStyles({
  container: {
    display: 'flex',
    justifyContent: 'center',
    '@media (max-width: 768px)': {
      '& .ant-pagination': {
        width: 'unset',
        '& .ant-pagination-options': {
          display: 'none',
        },
      },
    },
  },
});
